/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceRequest } from '../../models/invoice-request';

export interface ApiRequestInvoiceInitialGet$Params {
}

export function apiRequestInvoiceInitialGet(http: HttpClient, rootUrl: string, params?: ApiRequestInvoiceInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestInvoiceInitialGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceRequest>;
    })
  );
}

apiRequestInvoiceInitialGet.PATH = '/api/Request/Invoice/Initial';
